import { render, staticRenderFns } from "./KnowledgeDetailOverall.vue?vue&type=template&id=0d2e2c0c&"
import script from "./KnowledgeDetailOverall.vue?vue&type=script&lang=js&"
export * from "./KnowledgeDetailOverall.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeDetailOverall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports